/**
 * @param name Cookie name
 * @param value Cookie value
 * @param expireTime Expire time in milliseconds
 */
export function setCookie(name: string, value: any, expireTime: number): void {
    const date = new Date();
    date.setTime(date.getTime() + expireTime);

    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
}

/**
 * @param name Cookie name
 * @return string empty string if no value found
 */
export function getCookie(name: string): string {
    const cookies = document.cookie.split(';');

    let value = cookies.find((cookie) => cookie.trim().startsWith(`${name}=`))?.split('=')[1];
    if (typeof value === 'undefined') {
        value = '';
    }

    return value;
}
